/*
 * Defers loading of videos marked with [data-lazy-video] until they are
 * close to the viewport. Sources should use data-src instead of src.
 */
(function () {
  function loadVideo(video) {
    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.load();

    if (video.autoplay) {
      video.play().catch(() => {});
    }
  }

  function initLazyVideos(container) {
    const videos = container.querySelectorAll('video[data-lazy-video]');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(loadVideo);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          loadVideo(entry.target);
        });
      },
      { rootMargin: '0px 0px 400px 0px' }
    );

    videos.forEach((video) => observer.observe(video));
  }

  initLazyVideos(document);

  document.addEventListener('shopify:section:load', (event) => {
    initLazyVideos(event.target);
  });
})();
